import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { isRussianBlockedSelector } from '../../selectors/PurchaseMotionSelectors';
import RussianBlockedBanner from './RussianBlockedBanner';
import StarterPromotion2025BannerWrapper from './StarterPromotion2025BannerWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const BannerHierarchySection = ({
  screen
}) => {
  const isAppReady = useGlobalLoading();
  const isRussianBlocked = useSelector(isRussianBlockedSelector);
  if (!isAppReady) {
    return null;
  }
  if (isRussianBlocked) {
    return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
  }
  return /*#__PURE__*/_jsx(StarterPromotion2025BannerWrapper, {
    screen: screen
  });
};
export default BannerHierarchySection;